<div appBodyevents>
  <router-outlet></router-outlet>
  <app-mainloader></app-mainloader>
  <app-toaster></app-toaster>
</div>